export default __webpack_public_path__ + "static/media/settings.f8403ab9.svg";